import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=a674c914&scoped=true&"
import script from "./LogoutButton.vue?vue&type=script&lang=ts&"
export * from "./LogoutButton.vue?vue&type=script&lang=ts&"
import style0 from "./LogoutButton.vue?vue&type=style&index=0&id=a674c914&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a674c914",
  null
  
)

export default component.exports